import { Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useTheme, useToast } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { APIS, SF_MENU_MGMT, SG_MENU_LANG_LIST, URLS } from "@/tz/go/egaz/osci/ptl/ptl/menu/services/OsciMenuService";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const OSCI0104003S = (): JSX.Element => {
    const { pgeUid } = usePage({
        auth: ["auth_osci0003"],
    });
    const toast = useToast();
    const modal = useModal();
    const { theme } = useTheme();
    const navigate = useNavigate();
    const param = useParams();
    const langCodes = ["KO", "EN", "TZ"];

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0088" },
            { area: "comnCd", comnCd: "OSC0095" },
        ],
    });
    const form = {
        menuMgmt: useForm({ defaultSchema: SF_MENU_MGMT }),
    };

    const grid = {
        menuLangList: useGrid({ defaultSchema: SG_MENU_LANG_LIST }),
    };

    const fetch = {
        getMenuInfo: useFetch({
            api: (data: any) => APIS.getMenuInfo(data),
            onSuccess: (data: any) => {
                const { menuInfo } = data;
                if (comnUtils.isEmpty(menuInfo.content)) {
                    modal.openModal({ content: "msg.osc.00196" }); // Please select the menu. !== 메뉴를 선택하세요. ==!
                    handler.onListBtnClick();
                    return;
                }

                const { menuLangList, ...info } = menuInfo.content;

                form.menuMgmt.setValues(info);
                if (comnUtils.isEmpty(info.uprMenuId)) form.menuMgmt.setValue("uprMenuNm", "ROOT");

                menuLangList.forEach((item: any) => {
                    const key = item.langCd;
                    form.menuMgmt.setValue(`menuNm${key}`, comnUtils.replaceEmpty(item.menuNm, ""));
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // 조회가 실패하였습니다.
        }),
        updateMenuMgmt: useFetch({
            api: () =>
                APIS.updateMenuMgmt({
                    ...form.menuMgmt.getValues(),
                    menuLangList: grid.menuLangList.getData(),
                }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00073",
                    close: false,
                    onConfirm: () => {
                        handler.onListBtnClick();
                    },
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00045" }), // 저장이 실패하였습니다.
        }),
        deleteMenuMgmt: useFetch({
            api: () => APIS.deleteMenuMgmt({ ...form.menuMgmt.getValues() }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00071",
                    close: false,
                    onConfirm: () => {
                        handler.onListBtnClick();
                    },
                });
            },
            onError: (error: any) => {
                const { errorMessage } = error.response.data;
                modal.openModal({ content: errorMessage });
            },
        }),
    };

    const handler = {
        onListBtnClick: () => navigate(`${URLS.osci0104001q}`),
        onMenuMgmtSaveBtnClick: () => {
            form.menuMgmt.handleSubmit(
                () => {
                    modal.openModal({
                        content: "msg.osc.00058", // 저장하시겠습니까?
                        onConfirm: () => {
                            grid.menuLangList.clearData();

                            langCodes.forEach((langCd) => {
                                const menuNm = comnUtils.replaceEmpty(form.menuMgmt.getValue(`menuNm${langCd}`), "");
                                grid.menuLangList.addRow({ menuId: param.menuId, langCd: langCd, menuNm: menuNm });
                            });
                            fetch.updateMenuMgmt.fetch();
                        },
                    });
                },
                () => toast.showToast({ type: "warning", content: "msg.osc.00003" }),
            )();
        },
        onMenuMgmtDelBtnClick: () => {
            modal.openModal({
                content: "msg.osc.00062", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => fetch.deleteMenuMgmt.fetch(),
            });
        },
    };

    useEffect(() => {
        form.menuMgmt.setEditable("bsopClsfCd", false);
        form.menuMgmt.setEditable("ptlTpCd", false);

        if (comnUtils.isEmpty(param.menuId)) {
            modal.openModal({ content: "msg.osc.00196" }); // Please select the menu. !== 메뉴를 선택하세요. ==!
            handler.onListBtnClick();
            return;
        }

        fetch.getMenuInfo.fetch(param.menuId);
    }, [theme.lang]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.bsopClsfCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.ptlTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.uprMenuNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.menuId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.menuNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.menuOrd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.menuNmTZ} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.menuNmEN} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.menuNmKO} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.menuPrmtValue} />
                        </Group.Row>
                    </Group.Section>

                    <Group.Section hidden={true}>
                        {" "}
                        <Grid {...grid.menuLangList.grid} />{" "}
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onMenuMgmtSaveBtnClick} />
                    <Layout.Button role={"delete"} onClick={handler.onMenuMgmtDelBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
